// src/modules/app-views/products/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatabaseOutlined, ImportOutlined } from '@ant-design/icons';
import showMigrationModal from 'components/core/migration/MigrationSettingsModal';
import { showDataImportModal } from 'components/core/migration/DataImportModal';
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const productsInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
      dropdownDivider,

      // Data Import - import products from CSV/XLS/JSON
      {
        key: 'importData',
        label: 'data_import',
        icon: <ImportOutlined />,
        onClick: ({ refresh }) => {
          showDataImportModal({
            targetModule: 'products',
            moduleLabel: 'Produtos',
            onSuccess: () => refresh?.(),
          });
        },
      },

      {
        key: 'productsMigrationSettings',
        label: 'migratory',
        icon: <DatabaseOutlined />,
        onClick: ({ refresh }) => {
          showMigrationModal({
            // Hide recipient enrichment options (CNPJ/CPF) - not applicable for products
            showCnpjEnrichment: false,
            showCpfEnrichment: false,
            showProductsEnrichment: true,
            onSuccess: () => {
              // Refresh the list after migration settings change
              if (typeof refresh === 'function') {
                refresh();
              }
            },
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default productsInitMenuButton;
